const statsData = [
    { number: "15+", label: "Years of Experience" },
    { number: "50,000+", label: "Forms Processed" },
    { number: "24/7", label: "Immigration Support" },
    { number: "500+", label: "Qualified Lawyers" },
]

export default statsData;